var map = {
	"./attack.gif": 21213,
	"./ded.gif": 81880,
	"./dmg.gif": 64183,
	"./idle.gif": 36947,
	"./low.gif": 51237,
	"./ougi.gif": 89470,
	"./ready.gif": 31246,
	"./results.jpg": 74522,
	"./win.gif": 77125
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45564;